import * as React from 'react';
import { AnalyticsProvider, Grid } from 'telia-front-react';

interface FreeTrialMotivatorsProps {
  children: React.ReactNode;
}

const FreeTrialMotivators = (props: FreeTrialMotivatorsProps): JSX.Element => {
  return (
    <AnalyticsProvider group="Free Trial Motivators">
      <Grid align={['center-xs', 'middle-xs']}>{props.children}</Grid>
    </AnalyticsProvider>
  );
};

export default FreeTrialMotivators;
